module.exports = __webpack_public_path__ + "img/upload_wall_4.0a858f32.webp";